import { createApiSlice } from "@common";
import { CRUD_LEAD_TYPE } from "@routes";

const apiConfig = [
  {
    name: "addLeadType",
    method: "post",
    url: CRUD_LEAD_TYPE,
    stateKey: "message",
  },
  {
    name: "getLeadType",
    method: "get",
    url: CRUD_LEAD_TYPE,
    stateKey: "data",
  },
  {
    name: "updateLeadType",
    method: "put",
    url: CRUD_LEAD_TYPE,
    stateKey: "message",
  },
  {
    name: "deleteLeadType",
    method: "delete",
    url: CRUD_LEAD_TYPE,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "leadType",
  apiConfig,
  customReducers
);
const leadTypeSlice = slice;

export default leadTypeSlice.reducer;

export const {
  addLeadType,
  getLeadType,
  updateLeadType,
  deleteLeadType,
} = thunks;

export const { rowSelect } = actions;
